import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { Input, Form, FormGroup, FormFeedback, Button, Card, CardBody, Spinner } from 'reactstrap';
import { userActions } from '../../actions';
import { selectLoggingIn } from '../../redux/modules/authReducer';
import '../AuthForm.css';

const LoginForm = () => {
  const [user, setUser] = useState({
    email: '',
    password: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const loggingIn = useSelector(selectLoggingIn);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setUser(user => ({
      ...user,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (user.email && user.password) {
      dispatch(userActions.login(user, navigate));
    }
  };

  const invalidEmail = submitted && !user.email;
  const invalidPassword = submitted && !user.password;

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <Card>
          <CardBody>
            <div className="auth-header">
              <h2>Welcome Back</h2>
              <p>Sign in to your account</p>
            </div>

            <Form onSubmit={handleSubmit} className="auth-form">
              <FormGroup>
                <label className="form-label" htmlFor="email">Email Address</label>
                <Input
                  invalid={invalidEmail}
                  type="email"
                  name="email"
                  id="email"
                  placeholder="you@example.com"
                  onChange={handleChange}
                />
                <FormFeedback>Email address is required</FormFeedback>
              </FormGroup>

              <FormGroup>
                <label className="form-label" htmlFor="password">Password</label>
                <Input
                  invalid={invalidPassword}
                  type="password"
                  name="password"
                  id="password"
                  placeholder="Enter your password"
                  onChange={handleChange}
                />
                <FormFeedback>Password is required</FormFeedback>
              </FormGroup>

              <div className="auth-actions">
                <Link to="/forgotPassword" className="auth-link">Forgot Password?</Link>
              </div>

              <Button color="primary" disabled={loggingIn}>
                {loggingIn ? 'Signing in...' : 'Sign In'}
              </Button>

              {loggingIn && (
                <div className="auth-spinner">
                  <Spinner type="grow" />
                </div>
              )}

              <div className="auth-footer">
                <p>Don't have an account? <Link to="/register">Create one</Link></p>
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default LoginForm;
